import request from '@/utils/request'
// import { Notification } from 'element-ui'

/**
 * 获取用户列表
 */
export function getClientList() {
  return request({
    url: '/client/list',
    method: 'post'
  })
}

export function treeList() {
  return request({
    url: '/client/treeList',
    method: 'post'
  })
}

export function getClientTypes() {
  return request({
    url: '/client/GetClientTypes',
    method: 'get'
  })
}

export function edit(data) {
  return request({
    url: '/client/edit',
    method: 'post',
    data
  })
}

export function add(data) {
  return request({
    url: '/client/add',
    method: 'post',
    data
  })
}
